// extracted by mini-css-extract-plugin
export default {"minus":"MinimizeModal_minus__p5Nf9","container":"MinimizeModal_container__f2mA4","minimized":"MinimizeModal_minimized__0bpm2"};